module.exports = __webpack_public_path__ + "media/homeRun.2a21b470.mp4";